module.exports = __webpack_public_path__ + "static/media/Cart.a4cb220b.svg";